<template>
    <div
        class="fixed-top-right"
        :style="`top: 50px; right: ${$store.state.showRightMenu ? $store.state.rightMenuWidth : 0}px`"
        >
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'FixedButtons',
    }
</script>

<style scoped>

</style>